import { RiErrorWarningLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";

interface Props{
  pending:number
}
export default function UnpaidInvoice({pending}:Props) {
  const navigate = useNavigate();

  return (
    <div className="bg-[#E9D502] max-h-[200px]  md:px-0 px-2 pt-4  pb-4 text-center md:text-start  space-y-2 md:space-y-0 md:space-x-4 flex md:flex-row flex-col items-center md:justify-center">
      <RiErrorWarningLine size={22} />
      <p className="text-sm lg:text-xl text-[#3D2810] font-onestRegular">You have {pending} unpaid invoice(s)</p>
      <button
        className="bg-transparent border-[#3D2810] py-2.5 md:w-fit w-full border rounded-[8px] font-onestMedium text-[#3D2810] text-xs lg:text-base px-2"
        onClick={() => navigate("/dashboard/invoice")}>
        Pay Now!
      </button>
    </div>
  );
}